import './amounts-received.component.scoped.scss'
import CardAmountsReceived from './components/card-amounts-received/card-amounts-received.component'
import Heading from './components/heading/heading.component'
import { AmountsProvider } from './hooks/use-amounts-context/use-amounts-context.hook'
import useAmounts from './hooks/use-amounts/use-amounts.hook'

interface Props {
  onChange?: (hideValue: boolean) => any
}

const AmountReceived = ({ onChange }: Props) => {
  const { state, setState } = useAmounts()
  return (
    <AmountsProvider value={{ state, setState }}>
      <div className="amounts-received">
        <Heading onChange={onChange} />
        <CardAmountsReceived />
      </div>
    </AmountsProvider>
  )
}

export default AmountReceived
